module.exports = __webpack_public_path__ + "img/manipur.476c7390.svg";